import React from 'react';
import {
  renderToStaticMarkup,
} from 'react-dom/server';
import SVG from './SVG';
import {
  IExportInput,
} from './Utils';

const getSVGString = (input: IExportInput): string => {

  return renderToStaticMarkup(
    <SVG {...input}/>,
  );
};

export default getSVGString;
